import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingEntity } from '@inst-iot/bosch-angular-ui-components';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { VehicleInfoService } from 'src/app/_services/vehicle-info.service';
import { sortRbTableData } from 'src/app/_shared/utils/sort-utils';

@Component({
  selector: 'app-supported-vehicles',
  templateUrl: './supported-vehicles.component.html',
  styleUrls: ['./supported-vehicles.component.scss']
})
export class SupportedVehiclesComponent implements OnInit, OnDestroy {
  loader= new LoadingEntity();
  private readonly unsubscribe$ = new Subject<void>();
  supportedVehicles: any[] = []
  supportedCommercialVehicles: any[] = []

  readonly sortData = sortRbTableData;
  
  constructor(
    private readonly vehicleInfoService: VehicleInfoService,
  ) { }

  ngOnInit() {
    this.vehicleInfoService.getSupportedVehicles().pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (supportedVehicles) => {
        this.supportedVehicles = this.groupSupportedVehicles(supportedVehicles, 'passenger_car');
        this.supportedCommercialVehicles = this.groupSupportedVehicles(supportedVehicles, 'commercial_vehicle');
      },
      error: (error) => {
        console.error('Error fetching supported vehicles:', error);
      },
      complete: () => {
        this.supportedVehicles.sort((a, b) =>
          a.vehicleBrand.localeCompare(b.vehicleBrand)
        );

        this.supportedCommercialVehicles.sort((a, b) =>
          a.vehicleBrand.localeCompare(b.vehicleBrand)
        );
      }
    })
  }

  private groupSupportedVehicles(vehicles: any[], vehicleType: string): any[] {
    const filtered = vehicles.filter(v => v.vehicleType === vehicleType);
    
    const map = new Map<string, any>();
    let id = 1;
    filtered.forEach(v => {
      const batteryCapacityGross = v.grossEnergyWh ? +(v.grossEnergyWh / 1000).toFixed(1) : null;
      const batteryCapacityNet = v.netEnergyWh ? +(v.netEnergyWh / 1000).toFixed(1) : null;
      const key = `${v.vehicleBrand}|${v.vehicleModel}|${batteryCapacityGross ?? ''}|${batteryCapacityNet ?? ''}`;
      if (!map.has(key)) {
        map.set(key, {
          _id: id++ + '',
          vehicleBrand: v.vehicleBrand,
          vehicleModel: v.vehicleModel,
          vehicleType: vehicleType == 'passenger_car' ? 'Passenger Car' : 'Commercial Vehicle',
          batteryCapacity: batteryCapacityGross,
          batteryCapacityGross,
          batteryCapacityNet,
          modelYear: [v.modelYear],
          urlImage: v.urlImage
        });
      } else {
        const entry = map.get(key);
        if (!entry.modelYear.includes(v.modelYear)) {
          entry.modelYear.push(v.modelYear);
        }
      }
    });

    return Array.from(map.values()).map(v => ({
      ...v,
      modelYear: v.modelYear.sort()
    }));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
